import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { routes } from '../../routes';
import type { ClosedAgreementContactConfig } from './ClosedAgreement/hook';
import type { CheckoutSessionConfig } from './PaymentPrefs/hook';

const CheckoutPaymentPrefsPage = lazy(() => import('./PaymentPrefs'));
const CheckoutPaymentPrefsItauPage = lazy(() => import('./PaymentPrefsItau'));
const CheckoutClosedAgreement = lazy(() => import('./ClosedAgreement'));

type GTMTriggerFn = (variables?: Record<string, string | number>) => void;

export type CheckoutGroupConfig = {
  contactConfig?: ClosedAgreementContactConfig;
  sessionConfig?: CheckoutSessionConfig;
  trackGTM?: {
    trigger: {
      checkout: GTMTriggerFn;
      agreement: GTMTriggerFn;
    };
  };
};

const CheckoutGroup = ({ contactConfig, sessionConfig, trackGTM }: CheckoutGroupConfig = {}) => [
  <Route path={routes.checkoutPaymentPrefsItau.path} element={<CheckoutPaymentPrefsItauPage sessionConfig={sessionConfig} />} />,
  <Route path={routes.checkoutPaymentPrefs.path} element={<CheckoutPaymentPrefsPage sessionConfig={sessionConfig} trackGTM={trackGTM} />} />,
  <Route
    path={routes.checkoutClosedAgreement.path}
    element={<CheckoutClosedAgreement contactConfig={contactConfig} sessionConfig={sessionConfig} />}
  />,
];

export default CheckoutGroup;
